// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Roles_roles__o5AAK {
  display: flex;
  flex-wrap: wrap;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP {
  display: flex;
  flex-wrap: wrap;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY {
  border-radius: 5px;
  padding: 10px;
  margin-right: 15px;
  margin-bottom: 10px;
  min-width: 170px;
  max-width: 300px;
  height: fit-content;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_type__soyOh {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_role-info-personal__zy6wR {
  font-size: 12px;
  color: rgba(19, 19, 19, 0.6);
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_role-info-personal__zy6wR p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_role-info-personal__zy6wR .Roles_name__kPPVj {
  color: black;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 5px !important;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_role-info__Q9Yqv {
  font-size: 12px;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_role-info__Q9Yqv .Roles_name__kPPVj {
  color: black;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 5px !important;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_role-info__Q9Yqv .Roles_unit-permissions__3xCAZ {
  font-weight: 500;
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_information__XqGi2 .Roles_role-info__Q9Yqv .Roles_unit-permissions__3xCAZ span {
  color: rgba(19, 19, 19, 0.6);
}
.Roles_roles__o5AAK .Roles_account-roles__NXrdP .Roles_role__PufvY .Roles_delete-role__ZGmlS svg {
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.Roles_roles__o5AAK .Roles_add-more-role__eo0ci {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.Roles_roles__o5AAK .Roles_add-more-role__eo0ci svg {
  width: 35px;
  height: 35px;
}
.Roles_roles__o5AAK .Roles_add-more-role__eo0ci svg path {
  stroke: var(--profile-management-color);
  stroke-width: 0.5px;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountDetail/Components/Roles/Roles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;AACF;AAAE;EACE,aAAA;EACA,eAAA;AAEJ;AADI;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AAGN;AADQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAGV;AADQ;EACE,eAAA;EACA,4BAAA;AAGV;AAFU;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAIZ;AAFU;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAIZ;AADQ;EACE,eAAA;AAGV;AAFU;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAIZ;AAFU;EACE,gBAAA;AAIZ;AAHY;EACE,4BAAA;AAKd;AACQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACV;AAIE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAFJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAEM;EACE,uCAAA;EACA,mBAAA;AAAR","sourcesContent":[".roles {\n  display: flex;\n  flex-wrap: wrap;\n  .account-roles {\n    display: flex;\n    flex-wrap: wrap;\n    .role {\n      border-radius: 5px;\n      padding: 10px;\n      margin-right: 15px;\n      margin-bottom: 10px;\n      min-width: 170px;\n      max-width: 300px;\n      height: fit-content;\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      .information {\n        .type {\n          font-size: 18px;\n          font-weight: 500;\n          margin-bottom: 10px;\n        }\n        .role-info-personal {\n          font-size: 12px;\n          color: rgba($color: #131313, $alpha: 0.6);\n          p {\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n          }\n          .name {\n            color: black;\n            font-weight: 500;\n            font-size: 14px;\n            margin-bottom: 5px !important;\n          }\n        }\n        .role-info {\n          font-size: 12px;\n          .name {\n            color: black;\n            font-weight: 500;\n            font-size: 14px;\n            margin-bottom: 5px !important;\n          }\n          .unit-permissions {\n            font-weight: 500;\n            span {\n              color: rgba($color: #131313, $alpha: 0.6);\n            }\n          }\n        }\n      }\n      .delete-role {\n        svg {\n          width: 15px;\n          height: 15px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .add-more-role {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    svg {\n      width: 35px;\n      height: 35px;\n      path {\n        stroke: var(--profile-management-color);\n        stroke-width: 0.5px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roles": `Roles_roles__o5AAK`,
	"account-roles": `Roles_account-roles__NXrdP`,
	"role": `Roles_role__PufvY`,
	"information": `Roles_information__XqGi2`,
	"type": `Roles_type__soyOh`,
	"role-info-personal": `Roles_role-info-personal__zy6wR`,
	"name": `Roles_name__kPPVj`,
	"role-info": `Roles_role-info__Q9Yqv`,
	"unit-permissions": `Roles_unit-permissions__3xCAZ`,
	"delete-role": `Roles_delete-role__ZGmlS`,
	"add-more-role": `Roles_add-more-role__eo0ci`
};
export default ___CSS_LOADER_EXPORT___;
